import { useCallback, useEffect, useState } from 'react';
import Fab from '@material-ui/core/Fab';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'dva';
import LinkIcon from '@material-ui/icons/Link';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import ClearIconML from '@/components/ClearIconML/index';
import {
  Box,
  FormControl,
  TextField,
  MenuItem,
  Select,
  InputLabel,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import qs from 'qs';
import Button from '@material-ui/core/Button';
import { useLocation, history, useIntl } from 'umi';
import SearchGroupStyled from './SearchGroupStyled';
import webStorage from '@/utils/storageManager';

const SearchGroup = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const location = useLocation();
  const { query, pathname } = location;
  const isWmpPage = pathname.includes('/miniapps/template_list');
  const dispatch = useDispatch();
  const TEMPLATETYPE = webStorage.get('DICTOBJ')?.WECHAT_TEMP_MSG_TYPE;
  const {
    handleSearch,
    restClick,
    searchRef,
    setIsSearch,
    getWechatTemplateList,
  } = props;
  const { title, type, appId, tab = '1' } = query;
  const { handleSubmit, control, reset, getValues, setValue, watch } = useForm({
    defaultValues: {
      title,
      type,
      appId,
    },
  });
  //appid列表
  const { appIdList = [] } = useSelector((state) => state.templateList);
  //将appid
  const [appIdValue, setAppIdValue] = useState('');
  useEffect(() => {
    const isExist = appIdList?.some((i) => i.appId === appId);
    if (appId && isExist) {
      setAppIdValue(appId);
      setValue('appId', appId);
    } else if (appIdList) {
      setAppIdValue(appIdList[0]?.appId);
      setValue('appId', appIdList[0]?.appId);
    }
  }, [appId, appIdList, setValue]);

  const [titleValue, setTitleValue] = useState();
  //重置类型
  const watchType = watch('type');
  const handleClearType = () => {
    setValue('type', '');
  };
  const handleRestClick = () => {
    const resetSearch = {
      title: '',
      type: '',
    };
    setTitleValue('');
    reset(resetSearch);
    restClick && restClick(resetSearch);
  };
  //获取公众号列表
  const fetchAppIdList = useCallback(() => {
    dispatch({
      type: 'templateList/getAppIdList',
      payload: {
        values: { isWmpPage },
      },
      callback: () => {},
    });
  }, [dispatch, isWmpPage]);
  useEffect(() => {
    fetchAppIdList();
  }, [fetchAppIdList]);

  //同步微信模板
  const handleClickSyncTemplate = () => {
    dispatch({
      type: 'templateList/syncTemplate',
      payload: { values: { appId: getValues()?.appId, isWmpPage } },
      callback: (res) => {
        if (res.code === 0) {
          window.message.toast({
            type: 'success',
            message: '同步成功',
            title: '成功',
          });
          getWechatTemplateList();
        }
      },
    });
  };
  //赋值
  useEffect(() => {
    if (tab === '2') {
      setValue('title', title);
      setValue('type', type);
      setTitleValue(title);
    }
  }, [setValue, tab, title, type]);
  return (
    <SearchGroupStyled>
      <form onSubmit={handleSubmit(handleSearch)}>
        {tab === '1' ? (
          <Box className="search-wrapper">
            <Box className="left">
              <FormControl variant="standard" className="appId">
                <InputLabel>
                  {isWmpPage
                    ? '小程序'
                    : formatMessage({ id: 'wechat.official.n01.rdo01' })}
                </InputLabel>
                <Controller
                  render={(rp) => (
                    <Select
                      className="select"
                      label="appId"
                      name="appId"
                      value={rp.value ?? appIdValue}
                      onChange={(e) => {
                        setAppIdValue(e.target.value);
                        setValue('appId', e.target.value);
                        history.replace(
                          `${pathname}?${qs.stringify({
                            ...query,
                            appId: e.target.value,
                          })}`,
                        );
                      }}
                      placeholder=""
                      variant="standard"
                    >
                      {appIdList?.map((item) => (
                        <MenuItem
                          key={item.appId}
                          value={item.appId}
                          name={item.appId}
                        >
                          {item.nickName}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  label="appId"
                  name="appId"
                  placeholder=""
                  variant="standard"
                  control={control}
                />
              </FormControl>
            </Box>
            <Box className="button-group">
              <Fab
                data-log={JSON.stringify({
                  oid: 'btn_wechat_account_template_message_template_list_sync_to_wechat',
                  events: ['_ev', '_ec'],
                  params: {
                    appId: getValues()?.appId,
                  },
                })}
                variant="extended"
                size="small"
                color="primary"
                aria-label="add"
                className="export"
                onClick={handleClickSyncTemplate}
              >
                <LinkIcon sx={{ width: '24px', height: '24px' }} />
                同步微信模版
              </Fab>
            </Box>
          </Box>
        ) : (
          <Box className="search">
            <Box className="first">
              <FormControl variant="standard" className="appId">
                <InputLabel>
                  {isWmpPage
                    ? '小程序'
                    : formatMessage({ id: 'wechat.official.n01.rdo01' })}
                </InputLabel>
                <Controller
                  render={(rp) => (
                    <Select
                      className="select"
                      label="appId"
                      name="appId"
                      value={rp.value ?? appIdValue}
                      onChange={(e) => {
                        setAppIdValue(e.target.value);
                        setValue('appId', e.target.value);
                        setIsSearch(true);
                        history.replace(
                          `${pathname}?${qs.stringify({
                            ...query,
                            appId: e.target.value,
                          })}`,
                        );
                      }}
                      placeholder=""
                      variant="standard"
                    >
                      {appIdList?.map((item) => (
                        <MenuItem
                          key={item.appId}
                          value={item.appId}
                          name={item.appId}
                        >
                          {item.nickName}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  label={formatMessage({ id: 'wechat.official.n01.rdo01' })}
                  name="appId"
                  placeholder=""
                  variant="standard"
                  defaultValue={appIdValue}
                  control={control}
                />
              </FormControl>
            </Box>
            <Box className="second">
              <Box className="left">
                <Controller
                  render={(rp) => {
                    console.log('rp', rp);
                    return (
                      <TextField
                        value={rp.value ?? titleValue}
                        name="title"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                className="clear-btn"
                                onClick={() => {
                                  setTitleValue('');
                                  setValue('title', '');
                                }}
                                edge="end"
                              >
                                {titleValue ? (
                                  <ClearIcon className="clear-icon" />
                                ) : (
                                  ''
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        onChange={(e) => {
                          setTitleValue(e.target.value);
                          setValue('title', e.target.value);
                        }}
                        control={control}
                        id="basic"
                        variant="standard"
                        className="input"
                        label={
                          isWmpPage
                            ? '订阅消息名称'
                            : formatMessage({
                                id: 'wechat.official.n02.lbl01',
                              })
                        }
                        defaultValue={''}
                      />
                    );
                  }}
                  name="title"
                  control={control}
                  id="basic"
                  variant="standard"
                  className="input"
                  label={formatMessage({ id: 'wechat.official.n02.lbl01' })}
                  defaultValue={''}
                />
                <FormControl
                  variant="standard"
                  className="channel single-select"
                  sx={{ visibility: 'hidden' }}
                >
                  <InputLabel>
                    {formatMessage({ id: 'wechat.official.n02.rdo02' })}
                  </InputLabel>
                  <Controller
                    as={
                      <Select className="select">
                        {TEMPLATETYPE.map((item) => (
                          <MenuItem
                            key={item.dictCode}
                            value={item.dictCode}
                            name={item.dictCode}
                          >
                            {item.nameZh}
                          </MenuItem>
                        ))}
                      </Select>
                    }
                    label={formatMessage({ id: 'wechat.official.n02.rdo02' })}
                    name="type"
                    placeholder="全部类型"
                    variant="standard"
                    defaultValue=""
                    control={control}
                  />
                  <ClearIconML
                    handleClick={handleClearType}
                    clearValue={watchType}
                  ></ClearIconML>
                </FormControl>
              </Box>
              <Box className="button-group">
                <Button
                  variant="contained"
                  color="secondary"
                  className="reset"
                  startIcon={
                    <ReplayIcon sx={{ width: '16px', height: '16px' }} />
                  }
                  onClick={() => {
                    handleRestClick();
                  }}
                >
                  {formatMessage({ id: 'comm.action.btn.06' })}
                </Button>

                <Button
                  data-log={JSON.stringify({
                    oid: 'btn_wechat_account_template_message_list_search',
                    events: ['_ev'],
                    params: {
                      initUrl:
                        window.location.origin + window.location.pathname,
                    },
                  })}
                  ref={searchRef}
                  variant="contained"
                  type="submit"
                  className="search"
                  startIcon={
                    <SearchIcon sx={{ width: '16px', height: '16px' }} />
                  }
                >
                  {formatMessage({ id: 'comm.action.btn.01' })}
                </Button>
              </Box>
            </Box>
          </Box>
        )}
      </form>
    </SearchGroupStyled>
  );
};
export default SearchGroup;
